module.exports = __webpack_public_path__ + "media/VW_Skeeball_100pts_091120_enc-cs.dd659368.mp4";